/* Song List — fetches the Worker's /api/song-list catalog and renders
   packs + songs, with a Halloween/Christmas toggle when the section is
   set to both catalogs. One fetch covers both; the toggle re-renders
   from memory. All styling lives in song-list.css (.sl-pack / .sl-song
   are the modular units). */
(function () {
  'use strict';

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function linkHtml(url, label, modifier) {
    if (!url) return '';
    return (
      '<a class="sl-link sl-link--' + modifier + '" href="' + escapeHtml(url) +
      '" target="_blank" rel="noopener nofollow">' + label + '</a>'
    );
  }

  function songHtml(song) {
    var links = linkHtml(song.amazon_url, 'Amazon', 'amazon') + linkHtml(song.apple_url, 'iTunes', 'apple');
    return (
      '<li class="sl-song">' +
        '<div class="sl-song__title">' + escapeHtml(song.title) + '</div>' +
        (song.artist ? '<div class="sl-song__artist">' + escapeHtml(song.artist) + '</div>' : '') +
        (links ? '<div class="sl-song__links">' + links + '</div>' : '') +
      '</li>'
    );
  }

  function packHtml(pack) {
    var name = escapeHtml(pack.name);
    var color = pack.name_color && pack.name_color !== '#000000' ? ' style="color:' + escapeHtml(pack.name_color) + '"' : '';
    return (
      '<section class="sl-pack" id="pack-' + escapeHtml(pack.id) + '">' +
        '<header class="sl-pack__header">' +
          (pack.thumbnail_url
            ? '<img class="sl-pack__art" src="' + escapeHtml(pack.thumbnail_url) + '" alt="' + name + ' artwork" loading="lazy" width="48" height="48">'
            : '') +
          '<div>' +
            '<h3 class="sl-pack__name h3"' + color + '>' + name + '</h3>' +
            '<div class="sl-pack__count">' + pack.songs.length + (pack.songs.length === 1 ? ' song' : ' songs') + '</div>' +
          '</div>' +
        '</header>' +
        '<ul class="sl-songs">' + pack.songs.map(songHtml).join('') + '</ul>' +
      '</section>'
    );
  }

  function init() {
    var root = document.querySelector('[data-song-list]');
    if (!root) return;

    var api = root.dataset.api;
    var setting = root.dataset.holiday;
    var url = setting && setting !== 'all' ? api + '?holiday=' + encodeURIComponent(setting) : api;
    var loading = root.querySelector('[data-sl-loading]');
    var error = root.querySelector('[data-sl-error]');
    var toggle = root.querySelector('[data-sl-toggle]');
    var buttons = toggle ? Array.prototype.slice.call(toggle.querySelectorAll('[data-sl-holiday-btn]')) : [];
    var container = root.querySelector('[data-sl-packs]');

    var allPacks = [];
    var current = setting === 'all' ? 'halloween' : setting;

    // Must mirror the .sl-packs breakpoints in song-list.css.
    function colCount() {
      if (window.matchMedia('(max-width: 749px)').matches) return 1;
      if (window.matchMedia('(max-width: 989px)').matches) return 2;
      return 3;
    }

    function render() {
      // Alphabetical by pack name (API order is pack_number). The standalone
      // "More Songs" catch-all stays pinned to the end.
      var packs = allPacks
        .filter(function (pack) {
          return pack.holiday === current;
        })
        .sort(function (a, b) {
          var aStandalone = String(a.id).indexOf('standalone-') === 0;
          var bStandalone = String(b.id).indexOf('standalone-') === 0;
          if (aStandalone !== bStandalone) return aStandalone ? 1 : -1;
          return String(a.name).localeCompare(String(b.name), undefined, { sensitivity: 'base' });
        });
      // Deal packs across column wrappers so alphabetical order reads
      // left-to-right (pack 4 lands back under pack 1), while each column
      // still stacks tight regardless of card heights.
      var count = colCount();
      var cols = [];
      for (var i = 0; i < count; i++) cols.push([]);
      packs.forEach(function (pack, index) {
        cols[index % count].push(packHtml(pack));
      });
      container.innerHTML = cols
        .map(function (col) {
          return '<div class="sl-col">' + col.join('') + '</div>';
        })
        .join('');
      buttons.forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.dataset.slHolidayBtn === current ? 'true' : 'false');
      });
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.dataset.slHolidayBtn === current) return;
        current = btn.dataset.slHolidayBtn;
        render();
      });
    });

    // Re-deal the columns when a breakpoint changes the column count.
    ['(max-width: 749px)', '(max-width: 989px)'].forEach(function (query) {
      var mq = window.matchMedia(query);
      var handler = function () {
        if (allPacks.length) render();
      };
      if (mq.addEventListener) mq.addEventListener('change', handler);
      else mq.addListener(handler);
    });

    fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        loading.hidden = true;
        allPacks = data.packs || [];
        // The toggle earns its place only when both catalogs came back.
        var holidays = {};
        allPacks.forEach(function (pack) {
          holidays[pack.holiday] = true;
        });
        if (toggle && setting === 'all' && holidays.halloween && holidays.christmas) {
          toggle.hidden = false;
        }
        render();
      })
      .catch(function (err) {
        console.error('Song list failed to load:', err);
        loading.hidden = true;
        error.hidden = false;
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
